export class Paths {
  // Auth Routes
  static readonly AUTH = 'auth';
  static readonly SIGN_IN = 'sign-in';
  static readonly SIGN_UP = 'sign-up';
  static readonly INFLUENCER_SIGN_UP = 'influencer-sign-up';
  static readonly FORGOT_PASSWORD = 'forgot-password';
  static readonly VERIFY_OTP = 'verify-otp';
  static readonly RESET_PASSWORD = 'reset-password';

  // Raffle Routes
  static readonly RAFFLES = 'raffles';

  // Influencer Routes
  static readonly INFLUENCER = 'influencer';
  static readonly ALL_RAFFLES = 'all-raffles';
  static readonly CREATE_RAFFLE = 'create-raffle';
  static readonly RAFFLE_DETAILS = 'raffle-details';
  static readonly SHARE_RAFFLE = 'raffle-share';

  //Event Routes
  static readonly EVENT = 'event';

  // Tickets
  static readonly TICKETS_CHECKOUT = 'tickets-checkout';
  static readonly TICKETS_ORDER = 'tickets-order';
  static readonly MY_BOOKINGS = 'my-bookings';
  static readonly TICKETS = 'tickets';

  // Profile
  static readonly PROFILE = 'profile';

  // Poll
  static readonly POLL = 'poll';
  static readonly CREATE_POLL = 'create-poll';
  static readonly POLL_DETAILS = 'poll-details';

  // Posts
  static readonly POSTS = 'posts';
  static readonly POST = 'post';
  static readonly MEDIA = 'media';

  // Subscription
  static readonly SUBSCRIPTION = 'subscription';
  static readonly SUBSCRIPTIONS = 'subscriptions';
  static readonly CREATE_SUBSCRIPTION = 'create-subscription';
  static readonly SUBSCRIPTION_DETAILS = 'subscription-details';

  // Misc
  static readonly ID = ':/id';
  static readonly NOT_FOUND = '**';
  static readonly EMPTY = '';
}
